<template>
    <div class="bo-login-popup">
        <div
            class="modal-backdrop fade show"
            v-if="fade && visible"
        ></div>
        <form
            id="post-form"
            class="needs-validation"
            novalidate
            @submit.prevent="triggerAction"
        >
            <div
                v-if="visible"
                :id="id"
                :class="['modal bo-modal', modalName]"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-popup"
                style="display: block"
            >
                <div
                    :class="['modal-dialog modal-dialog-centered', modalStyle]"
                    role="document"
                    v-click-outside="deactivate"
                >
                    <div class="modal-content">
                        <div
                            v-if="!noTitle"
                            class="modal-header"
                        >
                            <div class="modal-title">
                                <img
                                    :src="siteLogoUrl"
                                    alt="Logo"
                                />
                            </div>
                            <button
                                v-if="isCloseable"
                                type="button"
                                class="close"
                                id="hideModal"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="deactivate"
                            >
                                <i class="icon-close"></i>
                            </button>
                        </div>

                        <div class="modal-body">
                            <!-- <slot name="body-content"></slot> -->
                            <div class="popup-login">
                                <div
                                    class="left-panel"
                                    :class="actionText == 'Open-Mail' ? ' expanded' : ''"
                                >
                                    <div
                                        class="select-tab top-side"
                                        v-if="actionText == 'Login' || actionText == 'Register'"
                                    >
                                        <div
                                            class="tab-class"
                                            :class="actionText == 'Login' ? ' selected' : ''"
                                        >
                                            <label
                                                class="tab-label"
                                                :class="actionText == 'Login' ? ' selected' : ''"
                                                @click="login"
                                                >{{ headerTranslations.login ?? 'Login'}}</label
                                            >
                                        </div>
                                        <div
                                            v-if="allowRegistration"
                                            class="tab-class"
                                            :class="actionText == 'Register' ? ' selected' : ''"
                                        >
                                            <label
                                                class="tab-label"
                                                :class="actionText == 'Register' ? ' selected' : ''"
                                                @click="register"
                                                >{{ headerTranslations.register ?? 'Register'}}</label
                                            >
                                        </div>
                                    </div>
                                    <div
                                        class="title"
                                        v-if="actionText == 'Forget-Password'"
                                    >
                                        {{ headerTranslations.reset_your_password_question ?? 'Reset Your Password?'}}
                                    </div>
                                    <div
                                        class="title"
                                        v-if="actionText == 'Reset-Password'"
                                    >
                                        {{ headerTranslations.reset_your_password_question ?? 'Reset Your Password?'}}
                                    </div>
                                    <div
                                        class="title"
                                        v-if="actionText == 'Open-Mail'"
                                    >
                                        {{ headerTranslations.check_your_email ?? 'Check Your Email'}}
                                    </div>
                                    <div
                                        class="title"
                                        v-else
                                    >
                                        {{ titleText }}
                                    </div>
                                    <div
                                        class="subtitle"
                                        v-if="actionText == 'Login'"
                                    >
                                        {{ headerTranslations.please_login_your_account_here ?? 'Please login your account here'}}
                                    </div>
                                    <div
                                        class="subtitle"
                                        v-else-if="actionText == 'Register'"
                                    >
                                        {{ headerTranslations.take_one_minute ?? 'It will take just 1 min'}}
                                    </div>
                                    <div
                                        class="subtitle"
                                        v-else-if="actionText == 'Forget-Password'"
                                    >
                                        {{ headerTranslations.enter_email_address_reset_password ?? 'Enter your e-mail address and we\'ll send you a link to reset your password'}}
                                    </div>
                                    <div
                                        class="subtitle"
                                        v-else-if="actionText == 'Reset-Password'"
                                    >
                                        {{ headerTranslations.enter_new_password_customer ?? 'Enter your new password for your account.'}}
                                    </div>
                                    <div
                                        class="subtitle"
                                        v-else-if="actionText == 'Open-Mail'"
                                    >
                                        {{ headerTranslations.email_sent ?? 'We sent an email to you at '}}<span class="email"> {{ email }}</span>.
                                        {{ headerTranslations.magic_link ?? 'It has a magic link that\'ll reset you password.'}}
                                    </div>
                                    <div
                                        class="login-svg"
                                        v-if="actionText === 'Login'"
                                    >
                                        <bo-svg
                                            :svg-content="loginTranslations.img_login_path ?? '/assets/graphics/img-login.svg'"
                                            :primary-color="primaryColor"
                                            :width="200"
                                            :height="200"
                                        ></bo-svg>
                                    </div>
                                    <div
                                        class="register-svg"
                                        v-if="actionText === 'Register'"
                                    >
                                        <bo-svg
                                            :svg-content="loginTranslations.img_register_path ?? '/assets/graphics/img-register.svg'"
                                            :primary-color="primaryColor"
                                            :width="200"
                                            :height="200"
                                        ></bo-svg>
                                    </div>
                                    <div
                                        class="forgotpassword-svg"
                                        v-if="actionText === 'Forget-Password'"
                                    >
                                        <bo-svg
                                            :svg-content="loginTranslations.img_resetpassword_path ?? '/assets/graphics/img-resetpassword.svg'"
                                            :primary-color="primaryColor"
                                            :width="200"
                                            :height="200"
                                        ></bo-svg>
                                    </div>
                                    <div
                                        class="resetpassword-svg"
                                        v-if="actionText === 'Reset-Password'"
                                    >
                                        <bo-svg
                                            :svg-content="loginTranslations.img_password_path ?? '/assets/graphics/img-password.svg'"
                                            :primary-color="primaryColor"
                                        ></bo-svg>
                                    </div>
                                    <div
                                        class="Mail-svg"
                                        v-if="actionText === 'Open-Mail'"
                                    >
                                        <bo-svg
                                            :svg-content="'/assets/graphics/img-email.svg'"
                                            :primary-color="primaryColor"
                                        ></bo-svg>
                                    </div>
                                </div>
                                <div
                                    class="right-panel"
                                    v-if="!(actionText == 'Open-Mail')"
                                >
                                    <div
                                        class="select-tab side-tab"
                                        v-if="actionText == 'Login' || actionText == 'Register'"
                                    >
                                        <div
                                            class="tab-class"
                                            :class="actionText == 'Login' ? 'selected' : ''"
                                        >
                                            <label
                                                class="tab-label"
                                                :class="actionText == 'Login' ? 'selected' : ''"
                                                @click="login"
                                                >{{ headerTranslations.login ?? 'Login'}}</label
                                            >
                                        </div>
                                        <div
                                            v-if="allowRegistration"
                                            class="tab-class"
                                            :class="actionText == 'Register' ? 'selected' : ''"
                                        >
                                            <label
                                                class="tab-label"
                                                :class="actionText == 'Register' ? 'selected' : ''"
                                                @click="register"
                                                >{{ headerTranslations.register ?? 'Register'}}</label
                                            >
                                        </div>
                                    </div>
                                    <div
                                        v-if="
                                            actionText == 'Login' ||
                                            actionText == 'Register' ||
                                            actionText == 'Forget-Password'
                                        "
                                    >
                                        <div class="form-group">
                                            <label>{{ headerTranslations.email ?? 'Email'}}</label>
                                            <input
                                                v-model="email"
                                                type="email"
                                                class="form-control"
                                                id="email"
                                                :placeholder="headerTranslations.email_placeholder ?? 'Eg. username@email.com'"
                                                required
                                            />
                                            <div
                                                v-if="alert1"
                                                class="alert-message"
                                                role="alert"
                                            >
                                                <i class="icon-cancelcircle-1"></i>
                                                {{ message }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div v-if="actionText == 'Login'">
                                                <label>{{ headerTranslations.password_login ?? 'Password Login'}}</label>
                                                <div class="password-container">
                                                    <input
                                                        v-model="password"
                                                        :type="showLoginPassword ? 'text' : 'password'"
                                                        class="form-control"
                                                        id="password_login"
                                                        :placeholder="headerTranslations.enter_password ?? 'Enter Password'"
                                                        required
                                                    />
                                                    <div
                                                        @click="toggleLoginPasswordVisibility"
                                                        class="toggle-password"
                                                    >
                                                        <i
                                                            :class="
                                                                showLoginPassword
                                                                    ? 'icon-visibility'
                                                                    : 'icon-visibilityoff'
                                                            "
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="alert4"
                                                    class="alert-message"
                                                    role="alert"
                                                >
                                                    <i class="icon-cancelcircle-1"></i>
                                                    {{ message }}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="form-group"
                                            v-if="actionText == 'Register'"
                                        >
                                            <label>{{ headerTranslations.phone ?? 'Phone'}}</label>
                                            <div class="input-group">
                                                <div class="dropdown">
                                                    <button
                                                        type="button"
                                                        class="form-control dropdown-toggle"
                                                        data-toggle="dropdown"
                                                        :aria-expanded="false"
                                                    >
                                                        {{ selectedCountry }}
                                                    </button>
                                                    <div
                                                        class="dropdown-menu shadow-sm overflow-auto w-auto p-0"
                                                        style="max-height: 200px;"
                                                    >
                                                        <div
                                                            v-for="(code, country) in countries"
                                                            :key="country"
                                                            class="dropdown-item d-flex justify-content-between px-3 py-2"
                                                            @click="selectedCountry = code"
                                                        >
                                                            <span class="text-left">{{ country }}</span>
                                                            <span class="text-right text-muted ms-2">{{ code }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <input
                                                    v-model="phone"
                                                    type="tel"
                                                    class="form-control"
                                                    id="phone"
                                                    :placeholder="headerTranslations.phone_placeholder ?? 'Eg. 123456789'"
                                                    required
                                                />
                                            </div>
                                            <div
                                                v-if="alert3"
                                                class="alert-message"
                                                role="alert"
                                            >
                                                <i class="icon-cancelcircle-1"></i>
                                                {{ message }}
                                            </div>
                                        </div>
                                        <div
                                            class="form-group"
                                            v-if="actionText == 'Register'"
                                        >
                                            <label>{{ headerTranslations.password ?? 'Password'}}</label>
                                            <div class="password-container">
                                                <input
                                                    v-model="register_password"
                                                    :type="showRegisterPassword ? 'text' : 'password'"
                                                    class="form-control"
                                                    id="register_password"
                                                    :placeholder="headerTranslations.enter_password ?? 'Enter Password'"
                                                    required
                                                />
                                                <div
                                                    @click="toggleRegisterPasswordVisibility"
                                                    class="toggle-password"
                                                >
                                                    <i
                                                        :class="
                                                            showRegisterPassword
                                                                ? 'icon-visibility'
                                                                : 'icon-visibilityoff'
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="forget-password">
                                            <label
                                                v-if="actionText == 'Login'"
                                                class="theme-primary-color"
                                                @click="forgetPassword"
                                                >{{ headerTranslations.reset_password ?? 'Reset Password'}}</label
                                            >
                                        </div>
                                        <div
                                            class="form-group"
                                            v-if="actionText == 'Register'"
                                        >
                                            <label>{{ headerTranslations.confirm_password ?? 'Confirm Password'}}</label>
                                            <div class="password-container">
                                                <input
                                                    :type="showConfirmPassword ? 'text' : 'password'"
                                                    class="form-control"
                                                    id="confirm_password"
                                                    name="confirm_password"
                                                    :placeholder="headerTranslations.enter_password ?? 'Enter Password'"
                                                    required
                                                />
                                                <div
                                                    @click="toggleConfirmPasswordVisibility"
                                                    class="toggle-password"
                                                >
                                                    <i
                                                        :class="
                                                            showConfirmPassword
                                                                ? 'icon-visibility'
                                                                : 'icon-visibilityoff'
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                            <div
                                                v-if="alert2"
                                                class="alert-message"
                                                role="alert"
                                            >
                                                <i class="icon-cancelcircle-1"></i>
                                                {{ message }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="actionText == 'Reset-Password'">
                                        <div class="form-group">
                                            <label>{{ headerTranslations.new_password ?? 'New Password'}}</label>
                                            <!-- <bo-password-meter :strength-meter="false"></bo-password-meter> -->
                                        </div>
                                        <div class="form-group">
                                            <label>{{ headerTranslations.repeat_new_password ?? 'Repeat New Password'}}</label>
                                            <!-- <bo-password-meter :strength-meter="false"></bo-password-meter> -->
                                        </div>
                                    </div>

                                    <div class="footer-content">
                                        <div class="side-info">
                                            <slot name="side-info"></slot>
                                        </div>

                                        <div class="button-groups">
                                            <slot name="button"></slot>
                                            <button
                                                v-if="actionText == 'Forget-Password'"
                                                type="button"
                                                class="btn-rounded btn-primary light button-half"
                                                @click="login"
                                            >
                                                {{ headerTranslations.cancel ?? 'Cancel'}}
                                            </button>

                                            <button
                                                type="button"
                                                class="btn-rounded action"
                                                v-if="actionText !== null && actionText != 'Open-Mail'"
                                                :class="actionText != 'Forget-Password' ? '' : 'button-half'"
                                                :disabled="disabled"
                                                @click="triggerAction"
                                            >
                                                {{ submitButtonText }}
                                            </button>
                                        </div>
                                    </div>

                                    <div
                                        v-if="notFound"
                                        class="alert alert-danger"
                                        role="alert"
                                    >
                                        {{ message }}
                                    </div>
                                </div>
                                <div
                                    class="right-panel open-mail"
                                    v-else-if="actionText == 'Open-Mail'"
                                >
                                    <div class="footer-content">
                                        <div class="button-groups">
                                            <button
                                                type="button"
                                                class="btn-rounded action"
                                                :disabled="disabled"
                                                @click="deactivate"
                                            >
                                                {{ submitButtonText }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="actionText == 'LLL'"
                                class="popup-register"
                            >
                                <div class="popup-img">
                                    <img
                                        :src="loginTranslations.img_register_path ?? '/assets/graphics/img-register.svg'"
                                        alt="Img"
                                    />
                                </div>
                                <div class="select-tab">
                                    <div class="tab-class">
                                        <label
                                            class="tab-label"
                                            @click="login"
                                            >{{ headerTranslations.login ?? 'Login'}}</label
                                        >
                                    </div>
                                    <div
                                        v-if="allowRegistration"
                                        class="tab-class selected"
                                    >
                                        <label
                                            class="tab-label active"
                                            @click="register"
                                            >{{ headerTranslations.register ?? 'Register'}}</label
                                        >
                                    </div>
                                </div>

                                <div class="title">
                                    {{ titleText }}
                                </div>
                                <div class="subtitle"></div>

                                <div class="form-group">
                                    <label>{{ headerTranslations.email ?? 'Email'}}</label>
                                    <input
                                        v-model="email"
                                        type="email"
                                        class="form-control"
                                        id="email"
                                        :placeholder="headerTranslations.email_placeholder ?? 'Eg. username@email.com'"
                                        required
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{ headerTranslations.password ?? 'Password'}}</label>
                                    <!-- <bo-password-meter
                                        :strength-meter="false"
                                    ></bo-password-meter> -->
                                    <input
                                        v-model="password"
                                        type="password"
                                        class="form-control"
                                        id="password"
                                        :placeholder="headerTranslations.enter_password ?? 'Enter Password'"
                                        required
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{ headerTranslations.confirm_password ?? 'Confirm Password'}}</label>
                                    <input
                                        type="password"
                                        class="form-control"
                                        id="confirm_password"
                                        name="confirm_password"
                                        :placeholder="headerTranslations.enter_password ?? 'Enter Password'"
                                        required
                                    />
                                    <!-- <bo-password-meter
                                        :strength-meter="false"
                                        name="confirm_password"
                                    ></bo-password-meter> -->
                                </div>
                            </div>
                            <div
                                v-if="actionText == 'LLLL'"
                                class="popup-forget"
                            >
                                <div class="popup-img">
                                    <img
                                        src="/assets/graphics/img-forgotpassword2.svg"
                                        alt="Img"
                                    />
                                </div>
                                <div class="title">{{ headerTranslations.reset_your_password_question ?? 'Reset Your Password?'}}</div>
                                <div class="subtitle">
                                    {{ headerTranslations.enter_email_address_reset_password ?? 'Enter your e-mail address and we\'ll send you a link to reset your password'}}
                                </div>
                            </div>
                            <div
                                v-else-if="actionText == 'VVVV'"
                                class="popup-mail"
                            >
                                <div class="popup-img">
                                    <img
                                        src="/assets/graphics/img-email.svg"
                                        alt="Img"
                                    />
                                </div>
                                <div class="title">{{ headerTranslations.check_your_email ?? 'Check Your Email'}}</div>
                                <div class="subtitle">
                                    {{ headerTranslations.email_sent ?? 'We sent an email to you at '}}<span class="email"> {{ email }}</span>.
                                    {{ headerTranslations.magic_link ?? 'It has a magic link that\'ll reset you password.'}}
                                </div>
                            </div>
                            <div
                                v-else-if="actionText == 'AAAA'"
                                class="popup-reset"
                            >
                                <div class="popup-img">
                                    <img
                                        :src="loginTranslations.img_resetpassword_path ?? '/assets/graphics/img-resetpassword.svg'"
                                        alt="Img"
                                    />
                                </div>
                                <div class="title">{{ headerTranslations.reset_your_password ?? 'Reset Your Password'}}</div>
                                <div class="subtitle">{{ headerTranslations.new_password_for_laderm ?? 'Enter your new password for your Laderm account.'}}</div>
                                <div class="form-group">
                                    <label>{{ headerTranslations.new_password ?? 'New Password'}}</label>
                                    <!-- <bo-password-meter :strength-meter="false"></bo-password-meter> -->
                                </div>
                                <div class="form-group">
                                    <label>{{ headerTranslations.repeat_new_password ?? 'Repeat New Password'}}</label>
                                    <!-- <bo-password-meter :strength-meter="false"></bo-password-meter> -->
                                </div>
                            </div>
                        </div>

                        <!-- <div class="modal-footer">
                            <div class="footer-content">
                                <div class="side-info">
                                    <slot name="side-info"></slot>
                                </div>

                                <div class="button-groups">
                                    <slot name="button"></slot>
                                    <button
                                        v-if="actionText == 'Forget-Password'"
                                        type="button"
                                        class="btn-rounded light button-half"
                                        @click="login"
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        v-else-if="actionText == 'Open-Mail'"
                                        type="button"
                                        class="btn-rounded light"
                                        data-dismiss="modal"
                                        @click="deactivate"
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        class="btn-rounded action"
                                        v-if="
                                            actionText !== null &&
                                            actionText != 'Open-Mail'
                                        "
                                        :class="
                                            actionText != 'Forget-Password'
                                                ? ''
                                                : 'button-half'
                                        "
                                        :disabled="disabled"
                                        @click="triggerAction"
                                    >
                                        {{ buttonText }}
                                    </button>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
Vue.component("bo-svg", require("js/frontend/components/bo-svg.vue").default);
import Vue from "vue";
import { showPageLoading, hidePageLoading } from "@/v2/utils/page-loading.js"; // #111741: never clear the shared veil by hand
import vClickOutside from "v-click-outside";
import api from "../../api";
import setAuthToken from "js/token";
import { parsePhoneNumberFromString } from 'libphonenumber-js'
Vue.use(vClickOutside);
export default {
    props: {
        id: {
            type: String,
            default: "bo-login-popup",
        },
        modalName: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        buttonText: {
            type: String,
            default: "",
        },
        modalStyle: {
            type: String,
            default: "",
        },
        action: {
            type: String,
            default: "",
        },
        actionType: {
            type: String,
            default: "",
        },
        message: {
            type: String,
            default: "",
        },
        active: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        noTitle: {
            type: Boolean,
            default: false,
        },
        fade: {
            type: Boolean,
            default: true,
        },
        siteLogoUrl: {
            type: String,
            default: "",
        },
        allowRegistration: {
            type: Boolean,
            default: false,
        },
        isCloseable: {
            type: Boolean,
            default: true,
        },
        buttonText: {
            type: String,
            default: "Login"
        },
    },
    data() {
        return {
            primaryColor: window.bo_primary_color || '#594c45',
            showLoginPassword: false,
            showRegisterPassword: false,
            showConfirmPassword: false,
            actionText: this.action,
            titleText: this.title,
            visible: this.active,
            headerTranslations: window?.bo?.headerTranslations ?? {},
            loginTranslations: window?.bo?.loginTranslations ?? {},
            submitButtonText: this.buttonText,
            notFound: false,
            alert1: false,
            alert2: false,
            alert3: false,
            alert4: false,
            email: "",
            phone: "",
            selectedCountry: '+60',
            // phoneError: '',
            countries: {
                Malaysia: '+60',
                Singapore: '+65',
                Taiwan: '+886',
                Japan: '+81',
            },
            validatedPhone: "",
            password: "",
            register_password: "",
            confirmPassword: "",
            url: document.getElementsByName("url")[0].getAttribute("content"),
            outletId: document.getElementsByName("outlet")
                ? document.getElementsByName("outlet")[0]?.getAttribute("content")
                : null,
            message: this.message,
            checkValidate: false,
            isSuccessLogin: false,
        };
    },
    watch: {
        active: function (n, o) {
            document.body.classList.toggle("modal-open");
            this.visible = n;
            if (n) {
                this.resetState();
            }
        },
    },
    mounted() {
        // add event listener on bootstrap modal close
        $(`#${this.id}`).on("hidden.bs.modal", () => {
            this.actionText = "Login";
            this.titleText = this.headerTranslations.login ?? "Login";
            this.submitButtonText = this.headerTranslations.login ?? "Login";
        });

        const checkTranslations = setInterval(() => {
            if (window?.bo?.headerTranslations) {
                this.headerTranslations = window.bo.headerTranslations;
            }
            if (window?.bo?.loginTranslations) {
                this.loginTranslations = window.bo.loginTranslations;
            }
            if (window?.bo?.headerTranslations && window?.bo?.loginTranslations) {
                clearInterval(checkTranslations);
            }
        }, 100);
    },
    methods: {
        toggleLoginPasswordVisibility() {
            this.showLoginPassword = !this.showLoginPassword;
        },
        toggleRegisterPasswordVisibility() {
            this.showRegisterPassword = !this.showRegisterPassword;
        },
        toggleConfirmPasswordVisibility() {
            this.showConfirmPassword = !this.showConfirmPassword;
        },
        activate() {
            this.visible = true;
            this.$emit("activate");
        },
        deactivate() {
            if (this.isCloseable || this.isSuccessLogin) {
                // Do not use visible with bootstrap modal
                // Now use bootstrap modal only
                this.visible = false;
                this.$emit("deactivate");
                // $(`#${this.id}`).modal("hide");
            }
        },
        triggerAction() {
            if (this.actionText == "Login") {
                this.postlogin();
            } else if (this.actionText == "Forget-Password") {
                this.postForgetPassword();
            } else {
                this.postRegister();
            }
            this.$emit("trigger");
        },
        register() {
            document.getElementById("email").classList.remove("is-invalid");

            var form = document.getElementById("post-form");
            form.classList.remove("was-validated");
            this.notFound = false;
            this.alert1 = false;
            this.alert2 = false;
            this.alert3 = false;
            this.alert4 = false;
            this.email = "";
            this.phone = "";
            // this.password = "";
            this.register_password = "";
            this.actionText = "Register";
            this.titleText = this.headerTranslations.register ?? "Register";
            this.submitButtonText = this.headerTranslations.confirm ?? "Confirm";
        },
        login() {
            document.getElementById("email").classList.remove("is-invalid");

            var form = document.getElementById("post-form");
            form.classList.remove("was-validated");
            document.getElementById("email").classList.remove("is-invalid");
            this.notFound = false;
            this.alert1 = false;
            this.alert2 = false;
            this.alert3 = false;
            this.alert4 = false;
            this.email = "";
            this.password = "";
            this.actionText = "Login";
            this.titleText = this.headerTranslations.login ?? "Login";
            this.submitButtonText = this.headerTranslations.login ?? "Login";
        },
        forgetPassword() {
            this.notFound = false;
            this.actionText = "Forget-Password";
            this.titleText = "";
            this.submitButtonText = this.headerTranslations.send ?? "Send";
        },
        openMail() {
            this.notFound = false;
            this.actionText = "Open-Mail";
            this.titleText = "";
            this.submitButtonText = this.headerTranslations.okay ?? "Okay";
        },
        resetPassword() {
            this.actionText = "Reset-Password";
            this.titleText = "";
            this.submitButtonText = this.headerTranslations.reset_password ?? "Reset Password";
        },
        resetState() {
            this.$nextTick(() => {
                var form = document.getElementById("post-form");
                if (form) {
                    form.classList.remove("was-validated");
                }
                const emailInput = document.getElementById("email");
                if (emailInput) {
                    emailInput.classList.remove("is-invalid", "is-valid");
                }
                const phoneInput = document.getElementById("phone");
                if (phoneInput) {
                    phoneInput.classList.remove("is-invalid", "is-valid");
                }
                const confirmPasswordInput = document.getElementById("confirm_password");
                if (confirmPasswordInput) {
                    confirmPasswordInput.classList.remove("is-invalid", "is-valid");
                    confirmPasswordInput.value = "";
                }
                const registerPasswordInput = document.getElementById("register_password");
                if (registerPasswordInput) {
                    registerPasswordInput.classList.remove("is-invalid", "is-valid");
                }
                const passwordLoginInput = document.getElementById("password_login");
                if (passwordLoginInput) {
                    passwordLoginInput.classList.remove("is-invalid", "is-valid");
                }
            });

            this.notFound = false;
            this.alert1 = false;
            this.alert2 = false;
            this.alert3 = false;
            this.alert4 = false;
            this.email = "";
            this.password = "";
            this.phone = "";
            this.register_password = "";
            this.actionText = this.action || "Login";
            this.titleText = this.title || (this.actionText == "Register" ? (this.headerTranslations.register ?? "Register") : (this.headerTranslations.login ?? "Login"));
            this.submitButtonText = this.buttonText || (this.actionText == "Register" ? (this.headerTranslations.confirm ?? "Confirm") : (this.headerTranslations.login ?? "Login"));
            this.message = this.headerTranslations.invalid_details ?? "Invalid Password/ Email";
        },

        validateEmail(mail) {
            var form = document.getElementById("post-form");
            if (mail == "") {
                this.message = this.headerTranslations.email_empty_error ?? "The email address cannot be empty!";
                form.classList.remove("was-validated");
                document.getElementById("email").classList.add("is-invalid");
                this.alert1 = true;
                this.alert2 = false;
                this.alert3 = false;
                this.notFound = false;
                this.checkValidate = false;
                return false;
            }

            var lastAtPos = mail.lastIndexOf("@");
            var lastDotPos = mail.lastIndexOf(".");
            var emailFormatPassed;
            emailFormatPassed =
                lastAtPos < lastDotPos &&
                lastAtPos > 0 &&
                mail.indexOf("@@") == -1 &&
                lastDotPos > 2 &&
                mail.length - lastDotPos > 2;

            if (emailFormatPassed) {
                document.getElementById("email").classList.remove("is-invalid");
                this.alert1 = false;
                this.notFound = false;
                this.checkValidate = true;
                return true;
            }
            this.message = this.headerTranslations.invalid_email ?? "Invalid email";
            form.classList.remove("was-validated");
            document.getElementById("email").classList.add("is-invalid");
            this.alert1 = true;
            this.alert2 = false;
            this.alert3 = false;
            this.notFound = false;
            this.checkValidate = false;
            return false;
        },
        validatePhone() {
            var form = document.getElementById("post-form");
            const input = document.getElementById("phone");
            input.classList.remove("is-invalid", "is-valid");

            if (!this.phone) {
                this.message = this.headerTranslations.phone_empty_error ?? "The phone number cannot be empty!";
                form.classList.remove("was-validated");
                input.classList.add("is-invalid");
                this.alert1 = false;
                this.alert2 = false;
                this.alert3 = true;
                this.notFound = false;
                this.checkValidate = false;
                return false;
            }

            const countryMap = {
                '+60': 'MY',
                '+65': 'SG',
                '+886': 'TW',
                '+81': 'JP'
            };

            const countryCode = countryMap[this.selectedCountry];

            const phoneNumber = parsePhoneNumberFromString(this.phone, countryCode);
            if (!phoneNumber || !phoneNumber.isValid()) {
                this.message = this.headerTranslations.invalid_phone ?? "Invalid phone";
                form.classList.remove("was-validated");
                input.classList.add("is-invalid");
                this.alert1 = false;
                this.alert2 = false;
                this.alert3 = true;
                this.notFound = false;
                this.checkValidate = false;
                return false;
            }

            this.validatedPhone = phoneNumber;
            this.message = "";
            input.classList.add("is-valid");
            this.alert3 = false;
            this.notFound = false;
            this.checkValidate = true;
            return true;
        },

        postlogin: function () {
            showPageLoading();

            var form = document.getElementById("post-form");
            form.classList.add("was-validated");

            if (!this.validateEmail(document.getElementById("email").value)) {
                hidePageLoading();
                document.getElementById("email").classList.add("is-invalid");
                return;
            }
            if ($("#password_login").val() == "") {
                hidePageLoading();
                document.getElementById("password_login").classList.add("is-invalid");
                this.alert4 = true;
                this.message = this.headerTranslations.password_empty_error ?? "The password cannot be empty!";
                this.checkValidate = false;
                return;
            }

            if (form.checkValidity()) {
                this.apiLogin();
                form.classList.remove("was-validated");
            }

            hidePageLoading();
        },
        apiLogin: function () {
            this.notFound = false;
            this.alert4 = false;
            var that = this;
            api.post(this.url + "/login", {
                baseUrl: this.url,
                email: this.email,
                password: this.password,
            })
                .then((response) => {
                    if (response.status == 200) {
                        // that.visible = false;
                        // Do not use visible with bootstrap modal
                        // Now use bootstrap modal only
                        this.isSuccessLogin = true;
                        this.deactivate();
                        setAuthToken(response.data.token);
                        alert(that.headerTranslations.login_successful ?? "Login Successful");
                        window.location.href = response.data.url;
                    } else {
                        that.alert4 = true;
                        this.message = that.headerTranslations.api_error ?? "Something Wrong happened";
                    }
                })
                .catch(function (error) {
                    hidePageLoading();
                    that.loggingIn = false;
                    that.alert4 = true;
                    const status = error?.response?.status;
                    if (status === 429) {
                        that.message =
                            that.headerTranslations.too_many_login_attempts ??
                            "Too many login attempts. Please wait a minute and try again.";
                    } else if (status === 401) {
                        that.message = that.headerTranslations.invalid_details ?? "Invalid Password/ Email";
                    } else {
                        that.message =
                            that.headerTranslations.api_error ?? "Something went wrong, please try again.";
                    }
                });
        },

        postRegister: function () {
            var form = document.getElementById("post-form");
            form.classList.add("was-validated");
            document.getElementById("email").classList.remove("is-invalid");
            if (
                document.getElementById("register_password").value != document.getElementById("confirm_password").value
            ) {
                form.classList.remove("was-validated");
                document.getElementById("confirm_password").classList.add("is-invalid");
                this.message = this.headerTranslations.password_mismatch ?? "The confirm password does not match the password entered.";
                this.alert1 = false;
                this.alert2 = true;
                this.alert3 = false;
                this.notFound = false;
            } else if (this.validateEmail(document.getElementById("email").value)) {
                if (this.validatePhone() && form.checkValidity()) {
                    this.alert1 = false;
                    this.alert2 = false;
                    this.alert3 = false;
                    this.alert4 = false;
                    this.notFound = false;
                    this.apiRegister();
                    document.getElementById("register_password").classList.remove("is-invalid");
                    document.getElementById("confirm_password").classList.remove("is-invalid");
                    showPageLoading();
                    form.classList.remove("was-validated");
                }
            }
        },

        apiRegister: function () {
            var that = this;
            api.post(this.url + "/register", {
                baseUrl: this.url,
                email: this.email,
                phone: this.validatedPhone,
                password: this.register_password,
                outletId: this.outletId,
            })
                .then((response) => {
                    hidePageLoading();
                    if (response.status == 200) {
                        $("#hideModal").trigger("click");
                        that.alert1 = false;
                        that.alert2 = false;
                        that.alert3 = false;
                        that.alert4 = false;
                        that.notFound = false;
                        that.message = "";
                        that.email = "";
                        that.phone = "";
                        that.register_password = "";
                        that.showRegisterPassword = false;
                        that.showConfirmPassword = false;
                        alert(that.headerTranslations.congrat_registration_successful ?? response.data.message, that.headerTranslations.registration_successful ?? "Registration Successful");
                    } else {
                        alert(response.data.error);
                    }
                })
                .catch(function (error) {
                    hidePageLoading();
                    that.loggingIn = false;
                    that.message = error.response.data?.error;
                    that.alert1 = false; // email
                    that.alert2 = false; // password
                    that.alert3 = false; // phone

                    if (that.message.includes("email")) {
                        that.message = that.headerTranslations.email_exist_error ?? "An account with this email already exists.";
                        document.getElementById("email").classList.add("is-invalid");
                        that.alert1 = true;
                    } else if (that.message.includes("phone")) {
                        that.message = that.headerTranslations.phone_exist_error ?? "An account with this phone already exists.";
                        document.getElementById("phone").classList.add("is-invalid");
                        that.alert3 = true;
                    } else {
                        that.notFound = true;
                        that.message = that.headerTranslations.api_error ?? "Something wrong happened";
                    }
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    }
                });
        },

        postForgetPassword: function () {
            showPageLoading();
            var form = document.getElementById("post-form");
            form.classList.add("was-validated");
            if (form.checkValidity()) {
                this.apiForgetPassword();
                form.classList.remove("was-validated");
            } else {
                hidePageLoading();
            }
        },

        apiForgetPassword: function () {
            this.notFound = false;
            var that = this;
            var postUrl = this.url + "/forgot-password";
            api.post(postUrl, {
                email: this.email,
            })
                .then((response) => {
                    if (response.data.status == 200) {
                        this.openMail();
                    } else {
                        this.message = response.data.message;
                        this.notFound = true;
                    }
                    hidePageLoading();
                })
                .catch(function (error) {
                    hidePageLoading();
                    that.loggingIn = false;
                    that.notFound = true;
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    }
                });
        },
    },
};
</script>
